import { baseStyleSheet } from '../../../styles/styles';
import { EntityInfoFieldLabel } from '../EntityInfoFieldLabel';
import { styleSheet } from './styles';
import { css } from 'aphrodite';
import Linkify from 'linkify-react';
import type { Opts } from 'linkifyjs';
import * as React from 'react';

interface IProps {
	className?: string;
	enableLinkify?: boolean;
	label?: string;
	truncateText?: boolean;
	value: React.ReactNode;
	valueClassName?: string;
}

export const EntityInfoField: React.FC<IProps> = props => {
	const { className, truncateText, value, label, valueClassName, enableLinkify } = props;
	if (!value) {
		return null;
	}

	// `ignoreTags` matches react-linkify's built-in skip list, so anchors/buttons
	// already present in `value` don't get a second <a> nested inside them.
	const linkifyOptions: Opts = {
		ignoreTags: ['a', 'button'],
		render: ({ attributes, content }) => (
			<a {...attributes} className={css(styleSheet.autoLink)} target='_blank' rel='noreferrer'>
				{content}
			</a>
		),
	};

	const renderOutput = (output: React.ReactNode) => {
		return (
			<div
				className={`${css(baseStyleSheet.breakWord)} ${valueClassName || ''} ${truncateText ? 'truncate-text' : ''}`}
			>
				{output}
			</div>
		);
	};

	return (
		<div className={`${css(styleSheet.container)} entity-info-field ${className || ''}`}>
			{!!label && <EntityInfoFieldLabel title={label} />}
			{enableLinkify ? <Linkify options={linkifyOptions}>{renderOutput(value)}</Linkify> : renderOutput(value)}
		</div>
	);
};
